import { Box, Stack, BoxProps } from '@chakra-ui/react';
import FullWidthBlock from '../FullWidthBlock';
import { CoreBlock } from '../../types';

interface CoreGroupProps {
  block: CoreBlock;
  boxProps?: BoxProps;
  renderBlocks: (block: CoreBlock, i: number) => JSX.Element;
}

const CoreGroup: React.FC<CoreGroupProps> = ({
  block,
  renderBlocks,
  boxProps = {},
}) => {
  const { align, backgroundColor } = block.attrs || {};
  const Wrapper = align === 'full' ? FullWidthBlock : Box;

  return (
    <Wrapper
      px={backgroundColor ? 6 : 0}
      py={backgroundColor ? [6, null, 12] : 0}
      bg={backgroundColor}
      borderRadius="xl"
      data-test-id="group"
      {...boxProps}
    >
      <Stack maxW="container.xl" marginX="auto" spacing={8}>
        {block.innerBlocks?.map(renderBlocks)}
      </Stack>
    </Wrapper>
  );
};

export default CoreGroup;
